module.exports = __webpack_public_path__ + "img/monitor-icon-active.4a2dd5cd.svg";